import { trustPoints } from "@/mocks/site";

export default function TrustBar() {
  return (
    <section className="border-y border-background-200 bg-background-100 py-10 md:py-14">
      <div className="site-container">
        <ul className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {trustPoints.map((point) => (
            <li key={point.title} className="flex items-start gap-3 rounded-lg bg-background-50 p-4">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-primary-100">
                <i className={`${point.icon} text-xl text-primary-700`} />
              </span>
              <div>
                <p className="font-heading text-base font-black text-foreground-950">{point.title}</p>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{point.text}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}